import { EXPERIENCE_LAYOUT_COMPONENTS } from '@common/experience-runtime/registry/experience-layout-components'
import { EVENTS_DETAIL_EXPERIENCE_COMPONENTS } from '@clientportal/cp-events-layer/experience/events-detail-experience.components'
import { EVENTS_DIRECTORY_EXPERIENCE_COMPONENTS } from '@clientportal/cp-events-layer/experience/events-directory-experience.components'
import { EVENTS_HUB_EXPERIENCE_COMPONENTS } from '@clientportal/cp-events-layer/experience/events-hub-experience.components'

export type ClientPortalV2ComponentImplementation = (context: {
  props: Record<string, unknown>
  children?: unknown
  emit: (event: string) => void
}) => unknown

export const CLIENTPORTAL_V2_COMPONENT_IMPLEMENTATIONS: Readonly<Record<string, ClientPortalV2ComponentImplementation>> = Object.freeze({
  'web.layout.grid': EXPERIENCE_LAYOUT_COMPONENTS.Grid,
  'web.layout.grid-item': EXPERIENCE_LAYOUT_COMPONENTS.GridItem,
  'web.layout.stack': EXPERIENCE_LAYOUT_COMPONENTS.Stack,
  'web.layout.surface': EXPERIENCE_LAYOUT_COMPONENTS.Surface,
  'clientportal.events.header': EVENTS_HUB_EXPERIENCE_COMPONENTS.EventsPageHeader,
  'clientportal.events.live-now': EVENTS_HUB_EXPERIENCE_COMPONENTS.EventsLiveNow,
  'clientportal.events.list': EVENTS_HUB_EXPERIENCE_COMPONENTS.EventsList,
  'clientportal.events.detail': EVENTS_DETAIL_EXPERIENCE_COMPONENTS.EventsDetail,
  'clientportal.events.directory': EVENTS_DIRECTORY_EXPERIENCE_COMPONENTS.EventsDirectory,
})
